import styled from 'styled-components'

export const StyledRegulation = styled.div`
	h3 {
		font-weight: bold;
	}

	p {
		font-size: 20px;
		line-height: 28px;
		margin-bottom: 10px;
		text-align: justify;
	}
`
